import * as React from "react";

import { renderButton_unstable } from "@fluentui/react-components";

import type { RibbonButtonInternalProps } from "../RibbonButton.props";
import { useRibbonButton } from "./useRibbonButton";
import { useRibbonButtonStyles } from "./useRibbonButtonStyles.styles";
import type { RibbonButtonProps } from "./RibbonButton.types";

/**
 * Define a styled `RibbonButton` using the `useRibbonButton` hook.
 */
export const RibbonButton = React.memo(
  React.forwardRef<HTMLButtonElement, RibbonButtonInternalProps>(
    (props, ref) => {
      "use forget";
      const state = useRibbonButton(
        {
          ...props,
          size: props.size?.toLowerCase() as RibbonButtonProps["size"],
        } as RibbonButtonProps,
        ref
      );

      // Apply styling.
      useRibbonButtonStyles(state);

      return renderButton_unstable(state);
    }
  )
);

RibbonButton.displayName = "next/RibbonButton";
